import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swiper_prev",
  "use": "icon-swiper_prev-usage",
  "viewBox": "0 0 27 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 44\" id=\"icon-swiper_prev\">\r\n<path d=\"M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol